import { serialize } from '~/editor/BufferEditor';
import { BufferEditor } from '~/editor/BufferEditor/types.plate';
import { LinkedInAnnotationElement } from '../nodes/LinkedInAnnotationElement';

export const getAllLinkedInAnnotations = (editor: BufferEditor) => {
  const { data } = serialize(editor);

  const entities = data[LinkedInAnnotationElement.type] || [];

  return entities;
};
